import { useMemo } from 'react';
import useSupport from 'data/hooks/useSupport';
import useBrands from 'data/hooks/useBrands';

const useConnect = () => {
  const { support, isLoading: isLoadingSupport } = useSupport();
  const { brands, isLoading: isLoadingBrands } = useBrands();

  const data = useMemo(() => {
    if (!support || brands.length === 0) {
      return {
        brandNumbers: [],
        integrationNumbers: [],
      };
    }

    const brandNumbers = support.brandNumbers.map(({ id, phoneNumber }) => {
      const brand = brands.find((brandId) => brandId.id === id);

      return {
        id,
        name: brand?.name,
        image: brand?.image,
        phoneNumber,
      };
    });

    const { integrations } = brands[0];

    const integrationNumbers = support.integrationNumbers.map(
      ({ id, phoneNumber, icon }) => {
        const integration = integrations.find(
          (integrationId) => integrationId.id === id,
        );

        return {
          id,
          name: integration?.name,
          image: {
            src: icon.small,
            alt: integration?.name.short || 'icon',
          },
          phoneNumber,
        };
      },
    );

    return {
      brandNumbers,
      integrationNumbers,
    };
  }, [support, brands]);

  return {
    isLoading: isLoadingSupport || isLoadingBrands,
    brandNumbers: data.brandNumbers,
    integrationNumbers: data.integrationNumbers,
  };
};

export default useConnect;
